import { render, staticRenderFns } from "./CampaignWinnerList.vue?vue&type=template&id=70881655&scoped=true&"
import script from "./CampaignWinnerList.vue?vue&type=script&lang=js&"
export * from "./CampaignWinnerList.vue?vue&type=script&lang=js&"
import style0 from "./CampaignWinnerList.vue?vue&type=style&index=0&id=70881655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70881655",
  null
  
)

export default component.exports